import { api } from '@/scripts/api';

export const PromoService = {
    /**
     * Get promos based on the query options.
     *
     * @param {{
     *      query?: ODataQueryOptions;
     *      signal?: AbortSignal;
     * }} options
     */
    async getPromos(options) {
        const queryParams = api.buildODataQuery(options.query ?? {});
        const endpoint = `/service/Promos${queryParams}`;
        return api.ajax({
            method: 'GET',
            url: endpoint,
            signal: options.signal,
        });
    },

    /**
     * Get a promo by ID.
     *
     * @param {number} id
     * @param {{
     *      query?: ODataQueryOptions;
     *      signal?: AbortSignal;
     * }} options
     */
    async getPromoById(id, options) {
        return this.getPromos({
            query: {
                ...(options?.query ?? {}),
                filter: {
                    ...(options?.query?.filter ?? {}),
                    Id: id,
                },
            },
            signal: options?.signal,
        });
    },

    /**
     * Calculate the billing amount for a promo.
     *
     * @param {number} usersCount
     * @param {{
     *     userPrice: number | null;
     *     basePrice: number | null;
     *     freeUsers: number | null;
     *     maxTier1Users: number | null;
     *     tier2UserPrice: number | null;
     * }} promo
     */
    calculateBillingAmount(usersCount, promo) {
        const basePrice = promo.basePrice ?? 0;
        const userPrice = promo.userPrice ?? 0;
        const freeUsersCount = promo.freeUsers ?? 0;
        const maxTier1Users = promo.maxTier1Users ?? 0;
        const tier2UserPrice = promo.tier2UserPrice ?? 0;

        const billableUsersCount = Math.max(usersCount - freeUsersCount, 0);

        let userAmount;
        if (maxTier1Users > 0)
        {
            const tierOneCount = Math.min(billableUsersCount, maxTier1Users);
            const tierOneAmount = tierOneCount * userPrice;

            let tierTwoCount = Math.max(billableUsersCount - tierOneCount, 0);

            let tierTwoAmount = 0;

            if (tierTwoCount > 0)
            {
                tierTwoAmount = tierTwoCount * tier2UserPrice;
            }

            userAmount = tierOneAmount + tierTwoAmount;
        }
        else
        {
            userAmount = billableUsersCount * userPrice;
        }

        const total = basePrice + userAmount;

        return total;
    }
};